import { Chip, Typography } from "@avenue-8/sidekick-ui";
import { SocialSignalsSection } from "./SocialSignalsSection";
import { useSocialSignals } from "./useSocialSignals";
import {
  Dot,
  Eyebrow,
  Header,
  HeaderTop,
  RadarPanelHeader,
  RadarPanelRoot,
} from "./ChatFocusView.styles";

export const RadarSignalsPanel = () => {
  const signalsQuery = useSocialSignals();
  const itemsCount = signalsQuery.data?.items.length ?? 0;

  return (
    <RadarPanelRoot>
      <RadarPanelHeader>
        <Header>
          <HeaderTop>
            <Dot />
            <Eyebrow variant="overline">Radar</Eyebrow>
          </HeaderTop>
          {itemsCount > 0 && (
            <Chip
              label={`${itemsCount} new`}
              size="small"
              color="primary"
              sx={{ "& .MuiChip-label": { fontWeight: 700 } }}
            />
          )}
        </Header>
        <Typography variant="h6">Life &amp; career moments</Typography>
        <Typography variant="body2">
          Social and public updates that create a natural reason to
          reconnect.
        </Typography>
      </RadarPanelHeader>
      <SocialSignalsSection />
    </RadarPanelRoot>
  );
};
